import { render } from "./AllCoupon.vue?vue&type=template&id=29690747"
import script from "./AllCoupon.vue?vue&type=script&lang=js"
export * from "./AllCoupon.vue?vue&type=script&lang=js"

import exportComponent from "/Users/niteshdas/Projects/wordpress/wp-content/plugins/easy-restaurant-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__